// Keep these values aligned with descope-iac/flows/add-passkey.json. The IaC
// graph owns the hosted flow, BYO screen, interactions, and terminal redirects.
export const ADD_PASSKEY_FLOW_ID = 'add-passkey';

export enum AddPasskeyScreenNames {
  ENROLLMENT = 'Add passkey',
}

export const ADD_PASSKEY_SCREEN_IDS = {
  ENROLLMENT: 'SC3AddPasskeyEnrollment',
} as const;

export const ADD_PASSKEY_INTERACTION_IDS = {
  CREATE: 'add-passkey-create',
  CANCEL: 'add-passkey-cancel',
} as const;
